import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Petition = ({ content }) => {
  if (!content) return null;

  return (
    <section className="py-16 bg-[#9E1B32] overflow-hidden" data-testid="petition-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
        <motion.h2
          className="text-2xl sm:text-3xl font-bold text-white mb-6 leading-tight"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-60px" }}
          data-testid="petition-title"
        >
          {content.petition_title}
        </motion.h2>
        <motion.div
          className="w-20 h-1 bg-white/30 mx-auto mb-6"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true, margin: "-60px" }}
        />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true, margin: "-60px" }}
        >
          <Button
            asChild
            size="lg"
            variant="outline"
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#9E1B32] px-8 py-6 text-base font-semibold"
            data-testid="petition-cta"
          >
            <Link to={content.petition_cta_url}>
              {content.petition_cta_text}
              <ArrowRight className="ml-2" size={18} />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default Petition;
